export enum NatureOfComplaint {
    DOMESTIC_ORDER_ENTRY = 'Domestic Order Entry',
    DOMESTIC_ITEM_OR_QUANTITY = 'Domestic Item or Quantity',
    DOMESTIC_PRODUCT_DATING = 'Domestic Product Dating',
    DOMESTIC_PRODUCT_DAMAGE = 'Domestic Product Damage',
    DOMESTIC_PRODUCT_TEMPERATURE = 'Domestic Product Temperature',
    DOMESTIC_DELIVERY = 'Domestic Delivery',
    DOMESTIC_INVOICE_ERROR = 'Domestic Invoice Error',
    DOMESTIC_BILLING_ADJUSTMENT = 'Domestic Billing Adjustment',
    DOMESTIC_ESKER = 'Domestic Esker',
    DOMESTIC_LARGE_INSTRUMENT_WAREHOUSE = 'Domestic Large Instrument Warehouse',
    INTERNATIONAL_ORDER_ENTRY = 'International Order Entry',
    INTERNATIONAL_ITEM_OR_QUANTITY = 'International Item or Quantity',
    INTERNATIONAL_PRODUCT_DATING = 'International Product Dating',
    INTERNATIONAL_PRODUCT_DAMAGE = 'International Product Damage',
    INTERNATIONAL_PRODUCT_TEMPERATURE = 'International Product Temperature',
    INTERNATIONAL_DELIVERY = 'International Delivery',
    INTERNATIONAL_DOCUMENTATION = 'International Documentation',
    INTERNATIONAL_INVOICE_ERROR = 'International Invoice Error',
    INTERNATIONAL_QUALITY = 'International Quality'
}
